import { type Brand, siteNames } from '@seek/melways-sites';
import type { EmployerSiteNames } from 'src/siteConfig';
import type { TrackJs } from 'src/utils/window';

const isJobsDBSite = (site: string): boolean =>
  site === siteNames.employer.seek.th || site === siteNames.employer.seek.hk;

const isJobStreetSite = (site: string): boolean =>
  site === siteNames.employer.seek.my ||
  site === siteNames.employer.seek.sg ||
  site === siteNames.employer.seek.id ||
  site === siteNames.employer.seek.ph;

const isANZSite = (site: string): boolean =>
  site === siteNames.employer.seek.au || site === siteNames.employer.seek.nz;

export const getBrandFromSiteForAnalytics = ({
  site,
  trackJs,
}: {
  site: EmployerSiteNames;
  trackJs: TrackJs | null;
}): Brand => {
  if (isANZSite(site)) {
    return 'seek';
  } else if (isJobStreetSite(site)) {
    return 'jobstreet';
  } else if (isJobsDBSite(site)) {
    return 'jobsdb';
  }

  trackJs?.track(
    new Error(`Analytics Brand Lookup Error - Unsupported site: ${site}`),
  );
  return 'seek';
};
